export default __webpack_public_path__ + "static/media/product.d47afd32.svg";